module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Query'), _vm._v(" "), _c('List'), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "1000",
      "title": "添加需求",
      "class-name": "vertical-center-modal"
    },
    model: {
      value: (_vm.modal10),
      callback: function($$v) {
        _vm.modal10 = $$v
      },
      expression: "modal10"
    }
  }, [_c('Add')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-daeab10a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/requirement/Index.vue
// module id = 19
// module chunks = 0